import { navSlice } from "./NavPanel.redux";

export const { setNavState, setIsNavPanelOpen } = navSlice.actions